import baseRoute from '../baseRoute';
import type { ReportTypeViewTableAdditionalFilter } from './queryParams';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/reportTypeView${`?startDate=${string}&endDate=${string}&page=${number}&limit=${number}&filterBy=${string}&sortBy=${string}&ascending=${boolean}&filterByReportTypeId=${number}&additionalFilters[]=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/reportTypeView`;

export const URL = (
	startDate: string,
	endDate: string,
	page: number,
	limit: number,
	filterText: string,
	sortBy: 'reportTypeName' | 'workOrderCode' | 'companyName' | 'startDate' | 'calculatedReportDisplayStatus' | 'reportTypeStatus' | '',
	sortAsc: boolean,
	filterByReportTypeId: number,
	additionalFilters: ReportTypeViewTableAdditionalFilter[]
): RouteDefinition =>
	`${baseRoute}/reportTypeView?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}&filterBy=${encodeURIComponent(filterText)}&sortBy=${sortBy}&ascending=${sortAsc}&filterByReportTypeId=${filterByReportTypeId}&additionalFilters[]=${encodeURIComponent(JSON.stringify(additionalFilters))}`;
